<template>
  <Popover popper-class="pg-batch-cell" trigger="click" v-model="visible" @show="popperShow">
    <template #reference>
      <i class="ivu-icon-icon-pg-edit pg-batch-cell-icon"></i>
    </template>
    <div class="pg-batch-cell__content" v-if="visible">
      <span class="pg-batch-cell__content-title">修改{{ column.label }}</span>
      <div class="pg-batch-cell__content-cont">
        <BatchCell v-model="batchValue" :extendCompileData="extendCompileData" :column="column" />
      </div>
      <div class="pg-batch-cell__content-footer">
        <Button type="primary" size="mini" round @click="setTableData()">设置所有行</Button>
        <Button type="primary" size="mini" round @click="setTableData('space')">仅设置空行</Button>
        <Button type="danger" size="mini" round @click="setTableData('remove')">清空所有行</Button>
      </div>
    </div>
  </Popover>
</template>
<script setup>
import { ref } from 'vue'
import { Popover, Button } from 'element-ui'
import BatchCell from './batch-cell-render'
import { getValueByPath, setValueByPathToVue } from '../../../utils/index'
import { useTemplate, useBeforValueActions } from '../../../hooks/index'

const props = defineProps({
  column: Object,
  extendCompileData: {
    type: Object,
    default: null,
  },
  batchRow: Function,
  tableData: Array,
})
const visible = ref(false)

const batchValue = ref(null)

const popperShow = () => {
  batchValue.value = null
}

const { getTemplateData, compileData } = useTemplate()
const { changeBorthers, beforValueAction } = props.column.parameter ?? {}
const { beforActions } = useBeforValueActions()

const setRowVal = (row, propsCompileData, val) => {
  beforActions({
    val,
    beforValueAction: compileData(beforValueAction, propsCompileData),
    field: props.column.property,
    formTableProperty: props.extendCompileData?.property,
    callback(resVal) {
      setValueByPathToVue(row, props.column.property, resVal)
      if (changeBorthers) {
        const temp = {}
        Object.keys(changeBorthers).forEach((im) => {
          let otherFields = changeBorthers[im]
          if (!otherFields) {
            temp[im] = otherFields
          } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
            temp[im] = compileData(otherFields, propsCompileData)
          } else {
            temp[im] = getValueByPath(resVal, otherFields)
          }
        })
        Object.keys(temp).forEach((im) => {
          setValueByPathToVue(row, im, temp[im])
        })
      }
    },
  })
}

//type 无值表示修改所有行， 为space时表示修改为空的行，remove表示清空所有行
const setTableData = async (type) => {
  if (props.batchRow) {
    await props.batchRow(type, props.column.property, type === 'remove' ? null : batchValue.value)
  } else if (props.tableData) {
    const propsCompileData = getTemplateData(null, { ...props.extendCompileData })
    for (const row of props.tableData) {
      if (type === 'remove') {
        setRowVal(row, { ...propsCompileData, row }, null)
      } else if (type === 'space') {
        const oldValue = getValueByPath(row, props.column.property)
        if (
          (!oldValue && oldValue !== 0 && oldValue !== false) ||
          (typeof oldValue === 'object' && oldValue?.id === '.')
        ) {
          setRowVal(row, { ...propsCompileData, row }, batchValue.value)
          setValueByPathToVue(row, props.column.property, batchValue.value)
        }
      } else {
        setRowVal(row, { ...propsCompileData, row }, batchValue.value)
      }
    }
  }
  visible.value = false
}
</script>
<style lang="scss">
@import '../style/batch-cell.scss';
</style>
